import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar'; // importe ta navbar

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-white"
    style={{ backgroundColor: '#1F7CAB' }} // ✅ couleur personnalisée
    >
      {/* Navbar en haut */}
      {/* <Navbar /> */}

      {/* Contenu principal */}
      <div className="p-8 max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Mentions légales</h1>
        <p className="mb-4">
          Dénomination sociale : VIP Events Inc.<br />
          Email : contact@vip-events-inc.com<br />
          SIREN : 944 065 382<br />
          SIRET (siège) : 944 065 382 00011<br /> 
          Forme juridique : SASU, société par actions simplifiée unipersonnelle<br />
          Numéro de TVA : FR52944065382<br />
          Inscription au RCS : INSCRIT  (au greffe de VERSAILLES , le 06/05/2025 )<br />
          Numéro RCS : 944 065 382 R.C.S. Versailles<br /> 
          Capital social : 200,00 €<br />

        </p>
        <p className="mb-4">
          Le contenu de ce site est fourni à titre informatif. Toute reproduction, intégrale ou partielle, est interdite sans autorisation.
        </p>
        <p>
          Hébergeur : VERCEL<br/><br/>
        </p>
        <p>
          Propriété intellectuelle :<br/>
          Tous les éléments du site Internet, des supports de communication et des documents émis par VIP Events INC (textes, visuels, logos, sons, vidéos, charte graphique, etc.) sont protégés par le Code de la propriété intellectuelle.<br/>
          Toute reproduction, représentation ou utilisation sans autorisation écrite est strictement interdite.<br/><br/>

          Protection des données :<br/>
          Les données personnelles collectées par VIP Events INC sont traitées conformément au Règlement (UE) 2016/679 dit RGPD.<br/>
          Le Client dispose d’un droit d’accès, de rectification, de suppression et d’opposition à ses données en écrivant à : contact@vip-events-inc.com<br/><br/>


          1. Objet<br/>
          Les présentes Conditions Générales de Vente (CGV) ont pour objet de définir les modalités et conditions selon lesquelles l’entreprise VIP Events INC (ci-après « le Prestataire ») propose ses services de production musicale, comprenant notamment :<br/>
          •	L’enregistrement professionnel,<br/>
          •	Le mixage et le mastering sur mesure.<br/>
          Toute commande implique l’adhésion pleine et entière du client (ci-après « le Client ») aux présentes CGV, sauf conditions particulières écrites et acceptées par les deux parties.<br/><br/>

          2. Prestations proposées<br/>
          Le Prestataire met à disposition son expertise, son matériel et son savoir-faire afin de fournir des services professionnels dans le domaine de la production musicale.<br/>
          Les prestations comprennent notamment :<br/>
          •	la mise à disposition d’un studio d’enregistrement équipé,<br/>
          •	la captation sonore et l’assistance technique,<br/>
          •	le mixage et le mastering,<br/>
          •	le conseil artistique éventuel selon les besoins du Client.<br/>
          Le Prestataire s’engage à exécuter les prestations avec soin, dans le respect des normes professionnelles et conformément aux spécifications convenues avec le Client.<br/><br/>

          3. Commande et devis<br/>
          Toute prestation donne lieu à l’établissement d’un devis détaillé précisant la nature des services, les tarifs, les délais estimatifs et les conditions de réalisation.<br/>
          Le devis est valable 30 jours à compter de sa date d’émission.<br/>
          La commande est considérée comme ferme dès la réception par le Prestataire du devis signé, accompagné de l’éventuel acompte mentionné sur celui-ci.<br/><br/>

          4. Tarifs et modalités de paiement<br/>
          Les prix sont exprimés en euros, hors taxes (HT) ou toutes taxes comprises (TTC) selon le statut du Prestataire.<br/>
          Les tarifs applicables sont ceux en vigueur au jour de la signature du devis.<br/>
          Sauf mention contraire, les paiements s’effectuent selon les modalités suivantes :<br/>
          •	Acompte à la commande : 30 %<br/>
          •	Solde à la livraison des fichiers finaux ou à la fin de la session d’enregistrement.<br/>
          Le paiement peut être effectué par virement bancaire, carte ou tout autre moyen accepté par le Prestataire.<br/>
          En cas de retard de paiement, des pénalités pourront être appliquées conformément à la législation en vigueur.<br/><br/>

          5. Conditions d’annulation ou de report<br/>
          Toute demande d’annulation ou de report doit être notifiée par écrit.<br/>
          •	Si l’annulation intervient plus de 7 jours avant la date prévue, l’acompte pourra être conservé à titre de dédommagement.<br/>
          •	Si elle intervient moins de 7 jours avant la date prévue, la totalité de la prestation pourra être facturée.<br/>
          Le Prestataire se réserve le droit d’annuler ou reporter une session pour des raisons techniques, de force majeure ou d’indisponibilité, après en avoir informé le Client dans les meilleurs délais.<br/><br/>

          6. Livraison des fichiers et propriété intellectuelle<br/>
          Les fichiers audios finaux (mixés, masterisés ou bruts) sont remis au Client sous format numérique via un lien de téléchargement ou sur support physique convenu.<br/>
          Le Prestataire conserve la propriété intellectuelle et les droits d’exploitation sur les enregistrements jusqu’au paiement intégral du prix convenu.<br/>
          Après règlement complet, les droits d’utilisation des fichiers audio sont transférés au Client, dans les limites précisées dans le devis ou le contrat.<br/>
          Le Prestataire se réserve toutefois le droit de conserver et d’utiliser des extraits à des fins promotionnelles ou de démonstration, sauf opposition écrite du Client.<br/><br/>

          7. Confidentialité<br/>
          Le Prestataire s’engage à respecter la confidentialité de toutes les informations, compositions ou œuvres enregistrées dans le cadre de la prestation.<br/>
          Le Client s’engage de son côté à ne pas divulguer d’informations confidentielles relatives au fonctionnement interne du studio ou au matériel utilisé.<br/><br/>

          8. Responsabilité<br/>
          Le Prestataire ne pourra être tenu responsable des pertes, détériorations ou dommages survenus à des supports fournis par le Client, sauf faute prouvée.<br/>
          En cas de force majeure ou d’incident technique indépendant de sa volonté, le Prestataire ne saurait être tenu pour responsable d’un retard ou d’une impossibilité temporaire d’exécution.<br/><br/>

          9. Données personnelles<br/>
          Les données collectées dans le cadre de la relation commerciale sont utilisées uniquement pour le traitement des commandes et la communication avec le Client, conformément au Règlement Général sur la Protection des Données (RGPD).<br/>
          Le Client peut à tout moment exercer ses droits d’accès, de rectification et de suppression de ses données en contactant le Prestataire par e-mail.<br/><br/>

          10. Droit applicable et juridiction compétente<br/>
          Les présentes CGV sont régies par le droit français.<br/>
          En cas de litige, et après tentative de résolution amiable, les tribunaux du ressort du siège social du Prestataire seront seuls compétents.<br/><br/>

          11. Acceptation<br/>
          Le Client reconnaît avoir pris connaissance des présentes Conditions Générales de Vente et les accepter sans réserve avant toute commande.<br/><br/>


















          Propriété intellectuelle :<br/>
          Tous les éléments du site Internet, des supports de communication et des documents émis par VIP Events INC (textes, visuels, logos, sons, vidéos, charte graphique, etc.) sont protégés par le Code de la propriété intellectuelle.<br/>
          Toute reproduction, représentation ou utilisation sans autorisation écrite est strictement interdite.<br/><br/>

          Protection des données :<br/>
          Les données personnelles collectées par VIP Events INC sont traitées conformément au Règlement (UE) 2016/679 dit RGPD.<br/>
          Le Client dispose d’un droit d’accès, de rectification, de suppression et d’opposition à ses données en écrivant à : contact@vip-events-inc.com<br/><br/>

          CONDITIONS GÉNÉRALES DE VENTE (CGV)<br/>
          1. Objet<br/>
          Les présentes Conditions Générales de Vente (CGV) ont pour objet de définir les conditions dans lesquelles VIP Events INC propose à ses clients des prestations de voyages sur mesure, de transport, de location de véhicules, et d’activités de loisirs en Afrique (principalement au Cameroun, au Sénégal et en Côte d’Ivoire).<br/>
          Toute commande implique l’adhésion pleine et entière du Client aux présentes CGV.<br/><br/>

          2. Prestations proposées<br/>
          VIP Events INC offre des prestations sur mesure, comprenant :<br/>
          •	la conception de voyages personnalisés,<br/>
          •	la réservation de logements, d’activités et de transports,<br/>
          •	la location de véhicules (avec ou sans chauffeur),<br/>
          •	les transferts aéroportuaires et les services taxi,<br/>
          •	les activités de loisirs et d’aventure (quad, jet-ski, scooter, etc.).<br/>
          Chaque prestation est détaillée dans un devis ou contrat précisant le contenu, le tarif et les conditions particulières.<br/><br/>
          ________________________________________<br/>
          3. Commande et validation<br/>
          Toute prestation fait l’objet d’un devis personnalisé.<br/>
          La commande devient ferme à réception du devis signé et de l’éventuel acompte.<br/>
          Aucune réservation ne sera confirmée sans validation écrite du Client.<br/><br/>

          4. Tarifs et modalités de paiement<br/>
          Les tarifs sont exprimés en euros TTC, sauf mention contraire.<br/>
          Ils incluent uniquement les prestations spécifiées dans le devis.<br/>
          Modalités de paiement :<br/>
          •	Acompte à la commande : [ex. 30 % du montant total]<br/>
          •	Solde : au plus tard 15 jours avant le départ ou l’événement prévu.<br/>
          Paiement en plusieurs fois :<br/>
          VIP Events INC pourra proposer un paiement fractionné selon les conditions suivantes :<br/>
          •	Une empreinte bancaire du montant total sera enregistrée lors de la validation.<br/>
          •	Après accord bancaire, le montant sera fractionné selon l’échéancier accepté.<br/>
          •	Toute mensualité impayée ou en retard entraînera une majoration de 10 % d’intérêts.<br/>
          •	Le montant total devra être intégralement réglé 15 jours avant le départ.<br/><br/>

          5. Annulation et modification<br/>
          Toute demande d’annulation ou de modification doit être transmise par écrit.<br/>
          Les conditions suivantes s’appliquent :<br/>
          •	Plus de 30 jours avant le départ : l’acompte reste acquis.<br/>
          •	Entre 30 et 15 jours avant le départ : 50 % du montant total est dû.<br/>
          •	Moins de 15 jours avant le départ : 100 % du montant total est dû.<br/>
          En cas de force majeure, un report ou avoir pourra être proposé.<br/><br/>


          6. Responsabilités<br/>
          VIP Events INC agit en qualité d’intermédiaire entre le Client et les prestataires (hôtels, transporteurs, guides, etc.).<br/>
          La société ne saurait être tenue responsable :<br/>
          •	des modifications imposées par des prestataires tiers,<br/>
          •	de la perte ou détérioration des effets personnels,<br/>
          •	ni des retards ou incidents survenus hors de son contrôle.<br/>
          Le Client est responsable de la conformité de ses documents de voyage (passeport, visa, vaccins...).<br/><br/>

          7. Assurances<br/>
          Le Client est invité à souscrire une assurance voyage couvrant les risques d’annulation, maladie, accident, vol ou perte de bagages.<br/>
          VIP Events INC peut proposer une assurance complémentaire sur demande.<br/><br/>

          8. Données personnelles<br/>
          Les données collectées servent uniquement à la gestion de la relation commerciale et au bon déroulement des prestations.<br/>
          Elles ne sont ni cédées, ni revendues.<br/>
          Conformément au RGPD, le Client peut exercer ses droits d’accès, de rectification et de suppression par e-mail à contact@vip-events-inc.com<br/><br/>

          9. Force majeure<br/>
          VIP Events INC ne saurait être tenue responsable des retards ou annulations dus à des circonstances imprévisibles (catastrophes naturelles, grèves, pandémies, troubles politiques, etc.).<br/>
          Dans la mesure du possible, une solution de report ou de remboursement partiel sera proposée.<br/><br/>

          10. Droit applicable et juridiction<br/>
          Les présentes CGV sont régies par le droit français.<br/>
          En cas de litige, et après tentative de conciliation amiable, les tribunaux compétents du siège social de VIP Events INC seront seuls compétents.<br/><br/>



          CONDITIONS PARTICULIÈRES DE VOYAGE SUR MESURE<br/>
          1. Itinéraires et prestations<br/>
          Les itinéraires, hébergements et activités proposés sont conçus sur mesure selon les souhaits du Client.<br/>
          Toute modification après validation du devis peut entraîner un ajustement tarifaire.<br/>
          2. Départs garantis<br/>
          Les départs sont confirmés dès validation du dossier complet et règlement du solde.<br/>
          En cas d’insuffisance de participants (dans le cas d’un voyage groupé), VIP Events INC se réserve le droit d’annuler ou de proposer une solution de remplacement équitable.<br/>
          3. Conditions d’hébergement<br/>
          Les hébergements proposés (hôtels, lodges, villas, etc.) sont sélectionnés selon la catégorie demandée par le Client.<br/>
          Toute réclamation sur place devra être formulée immédiatement auprès du représentant local pour permettre une résolution rapide.<br/>
          4. Transports et transferts<br/>
          Les transferts et trajets internes sont assurés par des partenaires agréés.<br/>
          Les horaires peuvent varier selon les conditions locales (climat, trafic, logistique).<br/>
          5. Activités et sécurité<br/>
          Les activités sportives, d’aventure ou de loisirs impliquent la pleine responsabilité du participant.<br/>
          Le Client doit s’assurer qu’il dispose d’une condition physique et d’une assurance adaptée.<br/>
          6. Documents de voyage<br/>
          Le Client doit s’assurer de la validité de son passeport, des visas requis et des vaccins nécessaires avant le départ.<br/>
          VIP Events INC ne pourra être tenue responsable d’un empêchement lié à la non-conformité des documents administratifs.<br/><br/>
          ________________________________________<br/>
          ACCEPTATION<br/>
          La validation d’un devis, la signature d’un contrat ou le paiement d’un acompte vaut acceptation complète des présentes Conditions Générales et Particulières de Vente.<br/><br/>




          Procédure de réclamation<br/>
          Toute réclamation relative à l’exécution d’une prestation fournie par VIP Events INC doit être formulée par écrit (courrier postal ou e-mail) dans un délai maximum de 30 jours à compter de la fin du voyage ou de la prestation concernée.<br/>
          La réclamation devra comporter les éléments suivants :<br/>
          •	les coordonnées complètes du Client,<br/>
          •	la référence du dossier ou de la réservation,<br/>
          •	la date et le lieu de la prestation,<br/>
          •	ainsi qu’une description précise du motif de la réclamation et, le cas échéant, les justificatifs correspondants (photos, échanges, factures, etc.).<br/>
          Après réception de la demande, VIP Events INC s’engage à accuser réception dans un délai de 10 jours ouvrés et à apporter une réponse motivée au Client dans un délai maximum de 30 jours calendaires.<br/>
          Si un accord amiable ne peut être trouvé, le Client pourra saisir le médiateur compétent du tourisme et du voyage ou toute autre instance de règlement amiable des litiges conformément à la législation en vigueur.<br/>
        </p>
      </div>
      {/* Bouton Accueil centré sous le contenu */}
      <div className="max-w-4xl mx-auto p-8 flex justify-center">
        <Link
          to="/"
          className="bg-yellow-500 hover:bg-yellow-600 text-black font-semibold px-6 py-3 rounded-full transition"
        >
          Accueil
        </Link>
      </div>
    </div>
  );
};

export default MentionsLegales;
